export default class PurchaseRequestActions {
  static NEW_DATA = "NEW_DATA";
  static UPDATE_DATA = "UPDATE_DATA";
  static SHOW_DATA = "SHOW_DATA";
  static VIEW_DATA = "VIEW_DATA";
  static DELETE_DATA = "DELETE_DATA";
  static ON_SUBMIT = "ON_SUBMIT";
  static ERROR_DATA = "ERROR_DATA";
  static PROCESS_DATA = "PROCESS_DATA";
  static RESET_DATA = "RESET_DATA";
  static BEFORE_PRINT_PR = "BEFORE_PRINT_PR";
  static PRINT_PR = "PRINT_PR";
  static GET_HELPER_PURCHASEREQUEST = "GET_HELPER_PURCHASEREQUEST";
  static GET_HELPER_PURCHASEREQUEST_FULL = "GET_HELPER_PURCHASEREQUEST_FULL";
  static SUCCESS_DATA = "SUCCESS_DATA";
  static ERROR_SERVER = "ERROR_SERVER";
  static RESET_LIST = "RESET_LIST";
  static ON_LIMIT_PRINT='ON_LIMIT_PRINT'
  static ON_SAVE_REQUEST_PRINT='ON_SAVE_REQUEST_PRINT'
  static submit() {
    return {
      type: PurchaseRequestActions.ON_SUBMIT,
    };
  }

  static create(data) {
    return {
      type: PurchaseRequestActions.NEW_DATA,
      payload: data,
    };
  }

  static update(data) {
    return {
      type: PurchaseRequestActions.UPDATE_DATA,
      payload: data,
    };
  }

  static view(data) {
    return {
      type: PurchaseRequestActions.VIEW_DATA,
      payload: data,
    };
  }

  static delete(data) {
    return {
      type: PurchaseRequestActions.DELETE_DATA,
    };
  }

  static list(data) {
    return {
      type: PurchaseRequestActions.SHOW_DATA,
      payload: data,
    };
  }
  static error(error) {
    return {
      type: PurchaseRequestActions.ERROR_DATA,
      payload: error,
    };
  }
  static success() {
    return {
      type: PurchaseRequestActions.SUCCESS_DATA,
    };
  }
  static process() {
    return {
      type: PurchaseRequestActions.PROCESS_DATA,
    };
  }
  static reset() {
    return {
      type: PurchaseRequestActions.RESET_DATA,
    };
  }
  static helper(data) {
    return {
      type: PurchaseRequestActions.GET_HELPER_PURCHASEREQUEST,
      payload: data,
    };
  }
  static helperFull(data) {
    return {
      type: PurchaseRequestActions.GET_HELPER_PURCHASEREQUEST_FULL,
      payload: data,
    };
  }

  static resetList() {
    return {
      type: PurchaseRequestActions.RESET_LIST,
    };
  }

  static beforePrint() {
    return {
      type: PurchaseRequestActions.BEFORE_PRINT_PR,
    };
  }
  
  static print(data) {
    return {
      type: PurchaseRequestActions.PRINT_PR,
      payload: data,
    };
  }
  static saveRequestPrint(){
    return {
      type: PurchaseRequestActions.ON_SAVE_REQUEST_PRINT,
    };
  }
  static limitPrint(){
    return {
      type: PurchaseRequestActions.ON_LIMIT_PRINT,
    };
  }
}
